import { Pin, PinComponent, PinSettings, PinType, isCategoryAreaPinComponent } from '@lessonup/pins-shared';
import { CategorySettings } from '../../pinComponents/CategoryAreaPinComponent/Category';

export function overridePinComponents(
  allPinComponentOnPin: PinComponent[],
  updatedPinComponents: PinComponent[]
): PinComponent[] {
  return allPinComponentOnPin.map((pinComponent) => {
    const mutatedPinComponent = updatedPinComponents.find(
      (mutatedPinComponent) => mutatedPinComponent.id === pinComponent.id
    );

    return mutatedPinComponent ?? pinComponent;
  });
}

export function updatePinSettings<P extends Pin>(pin: P, updatedSettings: Partial<PinSettings<PinType>>) {
  const newSettings = {
    ...pin.settings,
    ...updatedSettings,
  };

  return {
    ...pin,
    settings: newSettings,
  } as P; // Cast is needed because it refuses to merge the union of pins
}

export function updateCategorySettings(
  pinComponents: PinComponent[],
  pinComponentId: string,
  categoryId: string,
  settings: Partial<CategorySettings>
): PinComponent[] {
  return pinComponents.map((component) => {
    if (component.id === pinComponentId && isCategoryAreaPinComponent(component)) {
      const currentCategories = component.settings.categories || [];
      const updatedCategories = currentCategories.map((category: CategorySettings) => {
        if (category.id !== categoryId) return category;

        if (settings.style) {
          return { ...category, ...settings, style: { ...category.style, ...settings.style } };
        }

        return { ...category, ...settings };
      });

      return {
        ...component,
        settings: {
          ...component.settings,
          categories: updatedCategories,
        },
      } as PinComponent; // Cast is needed because it refuses to merge the union of pins
    }
    return component;
  });
}
